import React from "react";
import { graphql } from "gatsby";
import Seo from "../components/seo";

import MockupUI from "../components/modules/MockupUI";
import ImageUI from "../components/modules/ImageUI";
import ProductUI from "../components/modules/ProductUI";
// import Pre from "../components/ui/Pre";
import TiroirProduct from "../components/shop/TiroirProduct";

export const query = graphql`
  query Shop {
    allSanityProduct {
      nodes {
        ...product
      }
    }
  }
`;

const Shop = ({ data }) => {
  const { allSanityProduct } = data;

  const _canPurchase = (product) => {
    let _can = true;
    // console.log(product.title);
    const isDrop = product.productDrop && product.productDrop.dropDate;
    if (isDrop) {
      _can = product.productDrop.seconds >= 0;
      console.log(product.productDrop.seconds);
    }
    return _can;
  };

  const allSanityProductWithoutDrop = allSanityProduct.nodes.filter((el) =>
    _canPurchase(el)
  );
  return (
    <>
      <Seo
        pageTitle={"Shop"}
        pageDescription={""}
        // pageImage={seo.image.asset.url}
        template={`template-shop`}
        page={true}
      />

      {allSanityProductWithoutDrop.map((el, i) => (
        <TiroirProduct
          key={i}
          open={false}
          input={el}
          // color={el.color}

          card={
            <section className='section scrollY flex flex-row md:flex-col sm:scrollX '>
              {el.mockup ? (
                <MockupUI input={{ image: el.images[0] }} />
              ) : (
                el.images.map((image, j) => (
                  <ImageUI input={{ image: image }} key={j} />
                ))
              )}
            </section>
          }
          content={<ProductUI input={{ product: el }} />}></TiroirProduct>
      ))}
    </>
  );
};

export default Shop;
